import { clsx } from 'clsx'
import { type FC } from 'react'

import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { Skeleton } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { recommendationAccessorGetLocalizedProductPharmaForm } from '../../model/recommendationAccessorGetLocalizedProductPharmaForm'
import { recommendationAccessorGetLocalizedProductUnit } from '../../model/recommendationAccessorGetLocalizedProductUnit'

import styles from './RecommendationProductQuantity.module.css'

type RecommendationProductQuantityProps = {
  className?: string
  product?: GkAirRecommendedProductDataWeb
}

export const RecommendationProductQuantity: FC<
  RecommendationProductQuantityProps
> = ({ className, product }) => {
  const { locale } = useGlobalConfigContext()

  return (
    <span
      className={clsx(styles['recommendations-product-quantity'], className)}
    >
      {product ? (
        [
          `${Number(product.package_size)} ${recommendationAccessorGetLocalizedProductUnit(
            {
              locale,
              product,
            },
          )}`,
          recommendationAccessorGetLocalizedProductPharmaForm({
            locale,
            product,
          }),
        ]
          .filter(Boolean)
          .join(' | ')
      ) : (
        <Skeleton className="mx-auto w-1/2" />
      )}
    </span>
  )
}
